import { SECTION_CONTAINER } from "../../utils/layout";
import ScrollReveal, { revealItemProps } from "./ScrollReveal";
import "./LandingFeatures.css";

export function LandingFeatureItem({ feature, index, className = "", style }) {
  return (
    <li className={`landing-features__item ${className}`.trim()} style={style}>
      <span className="landing-features__index" aria-hidden="true">
        {String(index + 1).padStart(2, "0")}
      </span>
      <span className="landing-features__check" aria-hidden="true">
        ✓
      </span>
      <p className="landing-features__text">{feature}</p>
    </li>
  );
}

function LandingFeatureGrid({ features, labelledBy, embedded = false }) {
  const primaryRow = features.slice(0, Math.min(4, features.length));
  const secondaryRow = features.slice(4);
  const primaryRowClass =
    primaryRow.length <= 3
      ? "landing-features__row landing-features__row--three"
      : "landing-features__row landing-features__row--four";

  let revealIndex = 0;

  const content = (
    <ScrollReveal
      className={embedded ? "landing-features__grid" : "landing-features__grid landing-section__body"}
      stagger
      aria-labelledby={labelledBy || undefined}
    >
      <ul className={primaryRowClass}>
        {primaryRow.map((feature) => {
          const itemProps = revealItemProps(revealIndex);
          revealIndex += 1;
          return (
            <LandingFeatureItem
              key={`${feature}-${revealIndex}`}
              feature={feature}
              index={revealIndex - 1}
              {...itemProps}
            />
          );
        })}
      </ul>
      {secondaryRow.length > 0 ? (
        <ul className="landing-features__row landing-features__row--three">
          {secondaryRow.map((feature) => {
            const itemProps = revealItemProps(revealIndex);
            revealIndex += 1;
            return (
              <LandingFeatureItem
                key={`${feature}-${revealIndex}`}
                feature={feature}
                index={revealIndex - 1}
                {...itemProps}
              />
            );
          })}
        </ul>
      ) : null}
    </ScrollReveal>
  );

  if (embedded) {
    return content;
  }

  return <div className={SECTION_CONTAINER}>{content}</div>;
}

export default LandingFeatureGrid;
